import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { setAuthToken } from '../data/runtime';

/**
 * Tiny shim component: subscribes to the auth state and pushes the current
 * access token into the synchronous `runtime.ts` holder so `apiFetch` can
 * attach the Authorization header without each caller needing the auth hook.
 *
 * Mounted once near the top of the tree (in App / RequireAuth subtree).
 */
export function AuthTokenSync() {
  const { accessToken } = useAuth();
  useEffect(() => {
    setAuthToken(accessToken);
    return () => setAuthToken(null);
  }, [accessToken]);
  return null;
}
